import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getQRCodeRequest, clearQRCode } from '../../redux/actions/index.js';
import {
    QRCodeContainer,
    QRCodeText,
    QRCodeTextRegular,
    QRCodeWrapper,
    ButtonContainer,
} from './index.styled';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import QRCode from "react-qr-code";
import LoadingIndicator from 'src/common/refactoredComponents/spinner/Spinner.jsx';
import { useEffectWithErrorLogging} from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';
import { formatDateTimeForQR } from 'src/utils/dateUtils';
import { setQrGenerated } from 'src/common/redux/actions';
const TorqueQRCode = ({
    requestParams,
    //setShowTorqueQR=() => {},
    qrGenerated={},
    qrCodeData,
    qrCodeLoading,
    qrCodeError,
    onSuccess,
    onError,
    onClose=() => {},
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffectWithErrorLogging(() => {
        if (requestParams) {
            dispatch(getQRCodeRequest(requestParams));
        }

        return () => {
            dispatch(clearQRCode());
        };
    }, [dispatch, requestParams]);

    useEffectWithErrorLogging(() => {
        if (qrCodeData?.preSignedUrl && onSuccess) {
            onSuccess(qrCodeData);
        }
    }, [qrCodeData]);

    useEffectWithErrorLogging(() => {
        if (qrCodeError && onError) {
            onError(qrCodeError);
        }
    }, [qrCodeError]);

    if (!qrCodeData?.preSignedUrl || qrCodeLoading) {
        return <LoadingIndicator />;
    }

    if (qrCodeError) {
        return (
            <QRCodeContainer>
                {qrCodeError}
            </QRCodeContainer>
        );
    }

    if (!qrCodeData?.preSignedUrl) {
        return null;
    }

    // const onClose = () => {
    //     try {
    //         const myCaseRef = requestParams?.myCaseRef;
    //         setShowTorqueQR(false);
    //         if(myCaseRef && !qrGenerated[myCaseRef]) {
    //             dispatch(setQrGenerated({ [myCaseRef]: true }));
    //         }
    //     } catch (error) {
    //         logErrorToConsole(error);
    //     }
    // };
  
    //const qrValue = `${qrCodeData.preSignedUrl}?timestamp=${formatDateTimeForQR()}`;

    return (
        <QRCodeContainer id="qrcode-container">
            <QRCodeText>{t('orders.recordTorque.recordTorque')}</QRCodeText>
            <QRCodeTextRegular>{t('orders.recordTorque.recordTorqueMsg')}</QRCodeTextRegular>
             <QRCodeWrapper>
                <QRCode
                    size={232}
                    
                    value={qrCodeData?.preSignedUrl}
                    viewBox={`0 0 450 396`}
                />
             </QRCodeWrapper>
                   <ButtonContainer>
                       <Button
                            id={'torque-QRCode-close-button'}
                            show={true}
                            width={'127px'}
                            height={'40px'}
                            fontSize={'14px'}
                            margin={'0 5px 0 0'}
                            variant={ButtonStyles?.primary}
                            clicked={onClose}
                            >
                            {t('orders.recordTorque.closeWindow')}
                        </Button>
                   </ButtonContainer>
        </QRCodeContainer>
    );
};

export default TorqueQRCode;
